import { useContext, useEffect, useState } from 'react';
import type { ReactElement } from 'react';

import { ctxPluto } from '@/contexts/PlutoContext';
import { Target, TargetStatus } from '@/tmp';
import { Mode, SelectedRoute } from '@/types';
import { ctxUser } from '@/contexts/UserContext';
import { MinimalTarget } from '@/generated/model';
import { useUserPreferencesState } from '@/hooks/useUserPreferencesState';
import { normalizeSearchHistory } from '@/utilities/searchHistoryUtils';
import type { SearchHistory } from '@/utilities/searchHistoryUtils';

const SELECTED_TARGETS_PREFERENCES_KEY = 'selectedTargets';
const SEARCH_HISTORY_PREFERENCES_KEY = 'searchHistory';
const PATH_LENGTH_MINUTE_PREFERENCES_KEY = 'pathLengthMinutes';

// lehetne a neve olyan h ez a PlutoContext megvalositasa....
export default function GlobalStates({ children }: { children: ReactElement }) {
  const ctx = useContext(ctxUser);

  const [selectedTargets, setSelectedTargets] = useUserPreferencesState<MinimalTarget[]>(
    SELECTED_TARGETS_PREFERENCES_KEY,
    []
  );
  const [selectedTargetStatus, setSelectedTargetStatus] = useState<Map<number, TargetStatus>>(
    new Map<number, TargetStatus>()
  );
  const [selectedRoutes, setSelectedRoutes] = useState<SelectedRoute[]>([]);
  const [mode, setMode] = useState<Mode>('target');
  const [searchHistory, setSearchHistory] = useUserPreferencesState<unknown, SearchHistory>(
    SEARCH_HISTORY_PREFERENCES_KEY,
    { target: [], driver: [], userAccessControl: [] },
    normalizeSearchHistory
  );
  const [fullTargets, setFullTargets] = useState<Target[] | undefined>(undefined);
  const [focusedTarget, setFocusedTarget] = useState<Target | null | undefined>(undefined);
  const [popupTargetId, setPopupTargetId] = useState<number | undefined>(undefined);
  const [immediateLoadTargetId, setImmediateLoadTargetId] = useState<number | undefined>(undefined);
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState<boolean>(false);
  const [pathLengthMinutes, setPathLengthMinutes] = useUserPreferencesState<number>(
    PATH_LENGTH_MINUTE_PREFERENCES_KEY,
    60
  );

  useEffect(() => {
    function clearNonUserSpacedLocalStorage() {
      if (!ctx) return;
      [
        SELECTED_TARGETS_PREFERENCES_KEY,
        SEARCH_HISTORY_PREFERENCES_KEY,
        PATH_LENGTH_MINUTE_PREFERENCES_KEY,
        'userMessageTimeMillis',
        'zoom',
        'center',
        'route-only-poi-names',
        'tachographDiagram.target',
        'userId',
      ].forEach((m) => localStorage.removeItem(m));
    }

    clearNonUserSpacedLocalStorage();
  }, [ctx?.user]);

  useEffect(() => {
    const valuesSelectedTargetStatus = new Map<number, TargetStatus>(selectedTargets.map((t) => [t.id, 'unknown']));
    setSelectedTargetStatus(valuesSelectedTargetStatus); // FIXME nem tuti h ez kell, visszaallitsuk a statust ???
  }, [ctx?.user]);

  return (
    <ctxPluto.Provider
      value={{
        selectedTargets,
        setSelectedTargets,
        selectedTargetStatus,
        setSelectedTargetStatus,
        selectedRoutes,
        setSelectedRoutes,
        mode,
        setMode,
        searchHistory,
        setSearchHistory,
        fullTargets,
        setFullTargets,
        focusedTarget,
        setFocusedTarget,
        popupTargetId,
        setPopupTargetId,
        immediateLoadTargetId,
        setImmediateLoadTargetId,
        isBottomSheetOpen,
        setIsBottomSheetOpen,
        pathLengthMinutes,
        setPathLengthMinutes,
      }}
    >
      {children}
    </ctxPluto.Provider>
  );
}
